import config from "@/config"
import http from "@/utils/request"

export default {
	upload: {
		url: `${config.API_URL}/System/File/ReportFileName`,//上传杂志封面
		name: "文件上传",
		post: async function (data, config = {}) {  
			return await http.post(this.url, data, {
				headers: {
					"Content-Type": "multipart/form-data"
				}
			});
		}
	},
	
}